var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowViolet({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6.67,
    height: 11.35,
    viewBox: "0 0 6.67 11.35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1,11.35A1,1,0,0,1,.29,9.64l4-4-4-4A1,1,0,0,1,1.71.29L6.38,5a1,1,0,0,1,0,1.41L1.71,11.05A1,1,0,0,1,1,11.35Z",
    fill: "#32177a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowViolet);
export default __webpack_public_path__ + "static/media/arrow-violet.9a9195ce37729374eae81d2f8012bbe4.svg";
export { ForwardRef as ReactComponent };